import styled from 'styled-components'

export const LinkPreviewStyled = styled.div`
  padding-top: 16px;
`

export const LinkWrap = styled.div`
  padding: 10px 16px;
  display: flex;
  gap: 8px;
  border: 1px solid var(--t-link-preview-border);
  border-radius: 8px;
`

export const Link = styled.a`
  color: var(--t-action-accent);
  cursor: pointer;
  flex: 1 1 auto;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 20px;
`

export const CopyButton = styled.button`
  color: var(--t-link-preview-color);
  cursor: pointer;
  transition: 0.3s all ease;

  svg {
    display: block;
  }

  &:hover {
    color: var(--t-td-button-task-sidebar-icon-hover);
  }
`
